import React from 'react';
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import { Card,Tab,Tabs,Image } from 'react-bootstrap';
const FacilitiesResources = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const CampusAccess = [
        { link: "http://dl.acm.org/", image: "1416705177.png" },
        { link: "http://ieeexplore.ieee.org/Xplore/home.jsp", image: "665750214.png" },
        { link: "http://asmedigitalcollection.asme.org/index.aspx", image: "1418222594.png" },
        { link: "http://asmedigitalcollection.asme.org/index.aspx", image: "1122491370.png" },
        { link: "https://www.jstor.org/", image: "1242327303.png" },
        { link: "https://www.sciencedirect.com/browse/journals-and-books", image: "1043659958.png" },
        { link: "https://www.webofscience.com/wos/woscc/basic-search", image: "750304732.png" },
        { link: "https://hbsp.harvard.edu/home/", image: "604057102.png" },
        { link: "https://prowessiq.cmie.com/", image: "1924594202.png" },
        { link: "https://economicoutlook.cmie.com/", image: "746217215.png" },
        { link: "https://www.cambridge.org/core/", image: "523902848.png" },
    ];
    const OpenAccess = [
    {
        name: appLanguage === 'hi' ? "प्रवेश द्वार/निर्देशिका" : "Gateway/Directory",
        children: [
            { link: "http://www.scirus.com/", name: "Scirus :", disc: appLanguage === 'hi' ? "केवल वैज्ञानिक जानकारी के लिए" : "for scientific information only"},
            { link: "http://oajse.com/", name: appLanguage === 'hi' ? "ओपन एक्सेस जर्नल्स सर्च इंजन (OAJSE)" : "Open Access Journals Search Engine (OAJSE)", disc: ""},
            { link: "http://oaister.worldcat.org/", name: "OAIster :", disc: appLanguage === 'hi' ? "खुले पहुँच संसाधनों का प्रतिनिधित्व करने वाले लाखों अभिलेखों की यूनियन सूची" : "Union catalog of millions of records representing open access resources"},
            { link: "http://scholar.google.com/", name: "Google Scholar", disc: ""},
            { link: "http://worldwidescience.org/", name: "WorldWideScience.org", disc: appLanguage === 'hi' ? "एक वैश्विक विज्ञान प्रवेशद्वार है" : "is a global science gateway"},
            { link: "http://www.opendoar.org/", name: "DOAR :", disc: appLanguage === 'hi' ? "ओपन एक्सेस रिपोजिटरी की निर्देशिका" : "Directory of Open Access repository"},
            { link: "http://www.doaj.org/", name: "DOAJ :", disc: appLanguage === 'hi' ? "ओपन एक्सेस जर्नल की निर्देशिका" : "Directory of Open access journal"},
            { link: "http://www.doabooks.org/", name: "DOAB :", disc: appLanguage === 'hi' ? "ओपन एक्सेस पुस्तकों की निर्देशिका" : "Directory of Open Access Books"},
            { link: "http://www.openj-gate.com/", name: "Open JGate :", disc: appLanguage === 'hi' ? "ओपन एक्सेस जर्नल गेटवे" : "Open Acees journal gateway"},
        ],
    },
    {
        name: appLanguage === 'hi' ? "ईटीडी (इलेक्ट्रॉनिक थीसिस और शोध प्रबंध)" : "ETD (Electronic theses and dissertations)",
        children: [
            { link: "http://www.ndltd.org/serviceproviders/scirus-etd-search", name: appLanguage === 'hi' ? "नेटवर्क डिजिटल लाइब्रेरी ऑफ थीसिस एंड डिज़र्टेशन्स (NDLTD)" : "Networked Digital Library of Theses and Dissertations (NDLTD)", disc: appLanguage === 'hi' ? "दुनिया भर में प्रमुख भागीदार संस्थानों के ईटीडी तक एकल बिंदु पहुंच।" : "a single point access to ETDs of major participating institutions worldwide."},
            { link: "http://www.alldissertations.com/.index.php", name: "Alldissertations.com:", disc: appLanguage === 'hi' ? "दुनिया भर के विश्वविद्यालयों से शोध प्रबंध और थीसिस का संग्रह।" : "Collection of dissertations and theses from the universities all over the world."},
            { link: "http://ethos.bl.uk/", name: "EThOS :", disc: appLanguage === 'hi' ? "यूके उच्च शिक्षा द्वारा उत्पादित इन सभी तक पहुंच का एकल बिंदु।" : "single point of access to ALL theses produced by UK Higher Education."},
            { link: "http://www.dart-europe.eu/basic-search.php", name: appLanguage === 'hi' ? "डार्ट-यूरोप ई-थीसिस पोर्टल:" : "DART-Europe E-theses Portal:", disc: appLanguage === 'hi' ? "20 यूरोपीय देशों के 407 विश्वविद्यालयों से प्राप्त खुली पहुंच वाले शोध प्रबंध।" : "open access research theses from 407 Universities sourced from 20 European countries."},
            { link: "http://dspace.vidyanidhi.org.in:8080/dspace/", name: appLanguage === 'hi' ? "विद्यानिधि डिजिटल लाइब्रेरी और ई-स्कॉलरशिप पोर्टल" : "Vidyanidhi Digital Library and E-Scholarship Portal", disc: appLanguage === 'hi' ? "भारतीय ईटीडी संग्रह" : "Indian ETD Collection"},
            { link: "mailto: Shodhganga@INFLIBNET%20Centre", name: "Shodhganga@INFLIBNET Centre :", disc: appLanguage === 'hi' ? "भारतीय विश्वविद्यालयों के पीएच.डी. शोध प्रबंध" : "Ph.D. theses of Indian Universities"},
            { link: "http://www.diva-portal.org/smash/search.jsf", name: appLanguage === 'hi' ? "DiVA अकादमिक संग्रह ऑन-लाइन:" : "DiVA Academic Archive On-line :", disc: appLanguage === 'hi' ? "30 उच्च शिक्षा विश्वविद्यालय और कॉलेज" : "30 Universities and colleges of Higher education"},
        ],
    },
    {
        name: appLanguage === 'hi' ? "डिजिटल किताबें/पुस्तकालय" : "Digital Books/ Libraries",
        children: [
            { link: "http://arxiv.org/", name: "arXiv :", disc: appLanguage === 'hi' ? "भौतिकी, गणित, कंप्यूटर विज्ञान, मात्रात्मक जीवविज्ञान, मात्रात्मक वित्त और सांख्यिकी" : "Physics, Mathematics, Computer Science, Quantitative Biology, Quantitative Finance and Statistics"},
            { link: "http://citeseer.ist.psu.edu/index;jsessionid=D6012479F0D926C6C241315BC66C9C9C", name: "CiteSeerX  : ", disc: appLanguage === 'hi' ? "कंप्यूटर विज्ञान" : "Computer Science"},
            { link: "http://www.intechopen.com/", name: "InTechOpen :", disc: appLanguage === 'hi' ? "विज्ञान और प्रौद्योगिकी पर मुफ्त ई-पुस्तकें और पत्रिकाएँ" : "free E-books and Journals in science and technology"},
            { link: "http://www.dli.cdacnoida.in/", name: appLanguage === 'hi' ? "भारत की डिजिटल लाइब्रेरी" : "Digital library of India", disc: ""},
            { link: "http://www.digitalbookindex.org/about.htm", name: appLanguage === 'hi' ? "डिजिटल पुस्तक सूचकांक :" : "Digital Book Index :", disc: appLanguage === 'hi' ? "दुनिया भर में लाखों ई-पुस्तकें" : "Millions of e-books across the world"},
        ],
    },
    {
        name: appLanguage === 'hi' ? "प्रमुख ओपन एक्सेस जर्नल्स" : "Major Open Access Journals",
        children: [
            { link: "", name: "", disc: appLanguage === 'hi' ? "भारतीय विज्ञान अकादमी (11 पत्रिकाएँ)" : "Indian Academy of Science (11 journals)"},
            { link: "", name: "", disc: appLanguage === 'hi' ? "सीएसआईआर (भारत) जर्नल्स (17 जर्नल्स)" : "CSIR (India) Journals (17 Journals)"},
            { link: "", name: "", disc: appLanguage === 'hi' ? "PLOS जर्नल्स (7 जर्नल्स)" : "PLOS Journals (7 Journals)"},
        ],
    },
    ];
    const ArchitectureJournals = [
        { link: "http://abe.tudelft.nl/", image: "1257071163.png" },
        { link: "http://www.cityterritoryarchitecture.com/", image: "1272491808.gif" },
        { link: "http://ijpp.uniroma1.it/index.php/it", image: "1288042630.jpg" },
        { link: "http://conservation-science.unibo.it/", image: "1104616166.jpg" },
        { link: "http://jfa.arch.metu.edu.tr/", image: "831695249.png" },
        { link: "http://doiserbia.nb.rs/journal.aspx?issn=1450-569X", image: "1340341898.jpg" },
        { link: "http://www.urbanform.org/online_public/", image: "26294330.gif" },
        { link: "http://benthamopen.com/tousj/home", image: "1851207457.png" },
    ];
    const ParentComponent = ({ oa }) => 
    {
        return (
            <div>
            <h4>{oa.name}</h4>
            <ul>
                {oa.children.map((child,index) => (
                <li key={index}>
                    {child.link && <a href={child.link} target="_blank" rel="noopener noreferrer" className='fw-bold me-2 link-danger'>{child.name}</a>}
                    {child.disc && <span>{child.disc}</span>}
                </li>
                ))}
            </ul>
            </div>
        );
    };
    return (
        <Card className=' mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? "ई-संसाधन" : "E-RESOURCES"}
            </Card.Header>
            <Card.Body>
            <Tabs defaultActiveKey="0">
                <Tab eventKey={0} title={appLanguage === 'hi' ? "कैम्पस प्रवेश" : "Campus Access"}>
                    <ResponsiveMasonry columnsCountBreakPoints={{350: 1, 750: 2, 900: 4}}>
                        <Masonry gutter="10px">
                        {CampusAccess.map((ca, index) => (
                            <a href={ca.link} key={index} target="_blank" rel="noopener noreferrer">
                                <Image src={global.config.uploadPath+ca.image} fluid className='border p-2' />
                            </a>
                        ))}
                        </Masonry> 
                    </ResponsiveMasonry>                                   
                </Tab>
                <Tab eventKey={1} title={appLanguage === 'hi' ? "खुला उपयोग" : "Open Access"}>
                    {OpenAccess.map((oa,index) => (
                        <ParentComponent key={index} oa={oa} />
                    ))}                            
                </Tab>
                <Tab eventKey={2} title={appLanguage === 'hi' ? "आर्किटेक्चरल जर्नल एक्सेस" : "Architectural Journal Access"}>
                    <ResponsiveMasonry columnsCountBreakPoints={{350: 1, 750: 2, 900: 4}}>
                        <Masonry gutter="10px">
                        {ArchitectureJournals.map((aj, index) => (
                            <a href={aj.link} key={index} target="_blank" rel="noopener noreferrer">
                                <Image src={global.config.uploadPath+aj.image} fluid className='border p-2' />
                            </a>
                        ))}
                        </Masonry> 
                    </ResponsiveMasonry>                             
                </Tab>
            </Tabs>
            </Card.Body>
        </Card>
    );
}
export default FacilitiesResources;